import React, {useContext} from 'react';
import Grid from "@mui/material/Grid";
import {Divider, MenuItem, Typography} from "@mui/material";
import CustomText from "../inputs/CustomText";
import {
	codFRegister, codFRegisterNone,
	cognomeRegister, emailRegister, emailRegisterNone,
	nomeRegister,
	phoneRegister,
	phoneRegisterPrivate, valueRegister, valueRegisterNone
} from "../../../utils/RegisterUtils";
import {useFormContext} from "react-hook-form";
import {tipiDocumento} from "../../../utils/arrays/Generics";
import CustomSelect from "../inputs/CustomSelect";
import {referenceAsls} from "../../../utils/dictionaries/Generics";
import {AppContext} from "../../../App";
import {languages} from "../../../strings/LanguageDictionary";

export const AnagraficaTicket = ({classes, isCallReq = false, title = true, customTitle}) => {
	const {errors, watch, control} = useFormContext();
	const appContext = useContext(AppContext);

	return (
		<React.Fragment>
			{title ? <Grid item xs={12}>
				<Typography>
					<b>{languages[appContext.state.lang].ANAGRAFICA_FISRT_TEXT_TITLE__}</b>
				</Typography>
				<Typography color={"textSecondary"}>
					{languages[appContext.state.lang].ANAGRAFICA_FISRT_TEXT_SUBTITL}
				</Typography>
			</Grid> : customTitle}
			<Grid item xs={12} sm={6}>
				<CustomText
					control={control}
					rules={watch("documento") !== "" ? codFRegisterNone : codFRegister}
					name={"codF"}
					label={languages[appContext.state.lang].ANAGRAFICA__CODICE__FISCALE__}
					autoFocus={false}
					inputProps={{
						className: classes.input
					}}
					type={"text"}
					error={errors["codF"]}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<CustomText
					control={control}
					rules={isCallReq ? phoneRegister : watch("email")?.length > 0 ? phoneRegisterPrivate : phoneRegister}
					name={"cell"}
					placeholder={"3333333333"}
					label={languages[appContext.state.lang].ANAGRAFICA__CELLULARE__1__LBL + "*"}
					autoFocus={false}
					error={errors["cell"]}
					autoComplete={"phone"}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<CustomSelect
					name={"tipoDocumento"}
					label={languages[appContext.state.lang].ANAGRAFICA__METODO_IDENTIFIC_}
					control={control}
					defaultValue={tipiDocumento[0].val}
					autoFocus={false}
					rules={{required: watch("codF") === ""}}
					error={errors["tipoDocumento"]}
				>
					{
						tipiDocumento.map(value => {
							return (
								<MenuItem key={value.val} value={value.val}>{languages[appContext.state.lang][value.label]}</MenuItem>)
						})
					}
				</CustomSelect>
			</Grid>
			<Grid item xs={12} sm={6}>
				<CustomText
					control={control}
					rules={watch("codF") !== "" ? valueRegisterNone : valueRegister}
					name={"documento"}
					label={languages[appContext.state.lang].ANAGRAFICA__VALORE_DOCUMENTO_}
					autoFocus={false}
					inputProps={{
						className: classes.input
					}}
					type={"text"}
					error={errors["documento"]}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<CustomText
					control={control}
					rules={cognomeRegister}
					name={"cognome"}
					label={languages[appContext.state.lang].ANAGRAFICA__SURNAME_ + "*"}
					placeholder={"Rossi"}
					autoFocus={false}
					autoComplete={"family-name"}
					inputProps={{
						className: classes.capitalizeInput
					}}
					error={errors["cognome"]}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<CustomText
					control={control}
					rules={nomeRegister}
					name={"nome"}
					label={languages[appContext.state.lang].ANAGRAFICA__NAME_LBL + "*"}
					placeholder={"Giuseppe"}
					autoFocus={false}
					autoComplete={"given-name"}
					inputProps={{
						className: classes.capitalizeInput
					}}
					error={errors["nome"]}
				/>
			</Grid>
			<Grid item xs={12} sm={12}>
				<CustomText
					control={control}
					rules={
						watch("categoria") === "1" ? emailRegister : //Esoneri
							watch("categoria") === "3" ? emailRegister : //Tamponi
								watch("categoria") === "12" ? emailRegister : //Tamponi
								isCallReq ? emailRegisterNone : //Per tutto il resto c'è mastercard
									watch("cell")?.length > 0 ? emailRegisterNone : emailRegister}
					name={"email"}
					label={languages[appContext.state.lang].ANAGRAFICA__EMAIL___ + (isCallReq ? "" : "*")}
					autoFocus={false}
					placeholder={"rossi.giuseppe@gmail.com"}
					autoComplete={"email"}
					error={errors["email"]}
				/>
			</Grid>
			<Grid item xs={12}>
				<Divider style={{marginBottom: 20, marginTop: 20}}/>
			</Grid>

			<Grid item xs={12}>
				<Typography>
					<b>Seleziona l'ufficio o l'azienda che vuoi contattare:</b>
				</Typography>
			</Grid>
			<Grid item xs={12} sm={12}>
				<CustomSelect
					name={"domASL"}
					label={languages[appContext.state.lang].ANAGRAFICA__ASL_DOM_}
					control={control}
					defaultValue={"301"}
					disabled={watch("categoria") === "1"}
					autoFocus={false}
					none={true}
					noneValue={""}
					rules={{required: true}}
					error={errors["domASL"]}
				>
					{Object.entries(referenceAsls).map(([key, val]) => {
						return (
							<MenuItem value={key} key={key}>
								{val}
							</MenuItem>
						);
					})}
				</CustomSelect>
			</Grid>
		</React.Fragment>
	);
}
